<template>
  <div>
    <vx-card class="lg:w-full border border-solid d-theme-border-grey-light rounded mb-base" style=" height:110px;" label="select1">
      <div class="vx-row"  @click="editorInput()" >
        <vs-input class="w-full" style="width:10px; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;"
        :id="itemValue.id" v-model="title" disabled/>
      </div>
      <div>
        <div class="vx-row" style="width:100%;">
          <div>
            <div align="left">
              <vs-avatar :src="photoURL" size="30px"/>
            </div>
          </div>
          <div>
            <!-- <div align="left" >
              <vs-dropdown vs-custom-content vs-trigger-click >
                <p style="width:100; margin-top:5px; margin:3px; padding:5px;"> 링크 </p>
                <vs-dropdown-menu class="dropdown-login" >
                  <h3 class="mb-0">Link</h3>
                  <vs-input type="email" label-placeholder="url" v-model="urls"/>
                  <vs-button width="100%" color="primary" type="gradient" class="mt-4 w-full"  @click="updateUrls()">확인</vs-button>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div> -->
          </div>
          <div class="vx-row justify-end" style="margin-left:5px; margin-right:2px; padding:2px;">
            <vs-button v-if="userLevel" color="primary" type="flat" icon="icon-edit" icon-pack="feather" @click="showEditorPopup()"/>
            <vs-button v-if="userLevel" color="danger" type="flat" icon="icon-trash" icon-pack="feather" @click="remove()"/>
          </div>
        </div>
      </div>
    </vx-card>
    <vs-popup v-model="activeEditorForm" classContent="popup-example" title="Task 보기" :active.sync="activeEditorForm" style="z-index:10001">

      <div class="vx-row" style="margin:10px;">
        <vs-avatar :src="photoURL" size="30px"/>
        <p style="margin:5px;">{{userName}}</p>

        <!-- <div position-right class="justify-end">
          <vs-button style="align:right;" color="dark" type="flat" icon="icon-home" icon-pack="feather"/>
        </div><br/> -->
      </div>
      <vs-divider/>
      <vs-dropdown vs-trigger-click class="cursor-pointer" style="z-index:10002">
        <!-- <div class="p-3 rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-32"> -->
          <vs-chip class="flex items-center  justify-center ag-grid-cell-chipr" :color="chipColor(state)">
            <span>{{text(state)}}</span>
          </vs-chip>
        <!-- </div> -->
        <vs-dropdown-menu>
          <vs-dropdown-item  @click="editState(1)">
            <span class="flex items-center h-6">
              <vs-chip class="ag-grid-cell-chip" color="success" >
                <span>할일</span>
              </vs-chip>
            </span>
          </vs-dropdown-item>
          <vs-dropdown-item @click="editState(2)">
            <span class="flex items-center h-6">
              <vs-chip class="ag-grid-cell-chip" color="warning"  >
                <span>진행</span>
              </vs-chip>
            </span>
          </vs-dropdown-item>
          <vs-dropdown-item @click="editState(3)">
            <span class="flex items-center h-8">
              <vs-chip class="ag-grid-cell-chip" color="danger" >
                <span>완료</span>
              </vs-chip>
            </span>
          </vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>
      <vs-divider/>

      <vs-input placeholder="내용을 입력해주세요." v-model="title" class="mb-6 w-full" />
      <!-- <input type="text" class="inputx mb-3 titlefont" placeholder="제목" style="width:100%; margin:5px;" v-model="title" maxlength="30"/> -->
      <vs-divider/>
      <v-select class="w-full" v-model="blogSelected" placeholder="선택된 블로그가 없습니다" :options="blogs" />
      <div class="vx-row">
        <div align="left" class="w-4/5">
          <vs-input class="inputx mb-3 vs-input-no-border " placeholder="결과 URL 없음" style="width:100%; margin-left:10px; margin-right:15px;" v-model="urls" />
        </div>
        <div class="justify-end w-1/5">
          <!-- <div align="right"> -->
          <vs-button color="dark" type="flat" icon="icon-copy" icon-pack="feather" v-clipboard:copy="urls" v-clipboard:success="onCopy" v-clipboard:error="onError"/>
          <!-- </div> -->
        </div>
      </div>
      <vs-divider/>
      <vs-textarea label="설명" v-model="detail" style="font-family:'notokr';" /><br>
      <vs-button class="w-full" @click="submit()" color="dark" type="border">확인</vs-button>
    </vs-popup>
  </div>
</template>

<script>
import vSelect             from 'vue-select'

export default {
  props: ['itemValue'],
  data () {
    return {
      taskInfo:{},
      value1: '',
      val1:'test.filledyou.com/test',
      newItem: '',
      activeForm:1,
      userName: '',
      title: '',
      activeEditorForm: false,
      itemFocus: false,
      // editorButton:'',
      textarea:'',
      urls:'',
      userLevel: false,
      blogSelected:'',
      state:1,
      blogId:0,
      photoURL:'',
    }
  },
  components: {
    'v-select': vSelect,
  },
  watch: {
    blogSelected() {
      if(this.blogSelected){
        if(!this.urls){
          this.urls = 'https://filledyou.com/apps/project/main/project/'+this.$route.params.projectId+'/blog/'+this.blogSelected.id
        }
        this.blogId = this.blogSelected.id
      }else{
        this.blogId = 0
        if(this.urls && this.urls.toLowerCase().includes('/apps/project/main/project/')){
          this.urls = ''
        }
      }
    },
  },
  computed: {
    chipColor() {
      return (value) => {
        if(value === 1) return "success"
        else if(value === 2) return "warning"
        else if(value === 3) return "danger"
        else "success"
      }
    },
    text(){
      return (value) => {
        if(value === 1) return "할일"
        else if(value === 2) return "진행"
        else if(value === 3) return "완료"
        else "할일"
      }
    },
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    },
    activeProjectUserLevel() {
      return this.$store.state.project.ActiveProjectLevel
    },
    blogs(){
      return this.$store.state.task.blogs
    },
    // task(){
    //   return this.$store.getters['task/getTask'](this.itemValue.id)
    // }
  },
  created(){
    this.taskInfo = this.itemValue
    this.userName = this.itemValue.name
    this.detail = this.itemValue.detail
    this.title = this.itemValue.title
    // this.editorButton = 'editorButton'+String(this.itemValue.id)
    this.urls = this.itemValue.urls
    this.state = this.itemValue.state
    this.photoURL = require("@/assets/images/portrait/small/"+ this.itemValue.photo_url)
    this.userLevel = this.checkPermissions()
  },
  methods: {
    editState(value){
      this.state = value
    },
    checkPermissions (){
      if(this.activeProjectUserLevel >= 3){
        return true
      } else {
        if(this.activeProjectUserLevel >= 2 && this.itemValue.user_id == this.activeUserInfo.uid){
          return true
        }
      }
      return false
    },
    remove () {
      this.$emit('remove',this.itemValue.state,  this.itemValue.id)
    },
    editorInput () {
      if (this.activeProjectUserLevel >= 2 ){
        document.getElementById(this.itemValue.id).disabled = !document.getElementById(this.itemValue.id).disabled
        document.getElementById(this.itemValue.id).focus()
        if(this.title != this.itemValue.title){
          this.updateEvent()
        }
      }
    },
    // outFocus () {
    //   document.getElementById(this.itemValue.id).disabled = true
    //   if(this.title != this.itemValue.title){
    //     this.updateEvent()
    //   }
    // },
    showEditorPopup() {
      this.activeEditorForm = true
      this.blogId = 0
      this.taskInfo = this.itemValue
      this.userName = this.itemValue.name
      this.detail = this.itemValue.detail
      this.title = this.itemValue.title
      this.urls = this.itemValue.urls
      this.state = this.itemValue.state
      this.blogSelected = this.$store.getters['task/getBlog'](this.itemValue.pblog_id)
    },
    updateEvent(){
      // this.$emit('update', this.title, this.itemValue.id, this.itemValue.state)
      // if(this.itemValue.title != this.taskInfo.title || this.itemValue.urls[0] != this.taskInfo.urls[0] ||
      //   this.itemValue.detail != this.taskInfo.detail || this.itemValue.state != this.taskInfo.detail.state){
      // console.log(this.itemValue)
      // console.log(this.itemValue.state)
      var oldState = this.itemValue.state
      this.$store.dispatch('task/updateTask', {id:this.itemValue.id, title:this.title, detail: this.detail, urls:this.urls, state:this.state, blog_id:this.blogId}).then(()=>{
        if(this.state != oldState){
          this.$emit('update', {id:this.itemValue.id, oldState:oldState, state:this.state, })
        }
      })
      // }
    },
    selectTask() {
      this.$emit('selectTask', this.itemValue.id)
    },
    submit(){
      this.activeEditorForm = false
      if(this.itemValue.title != this.title || this.itemValue.urls != this.urls || this.itemValue.pblog_id != this.blogId ||
        this.itemValue.detail != this.detail || this.itemValue.state != this.state ){
        this.updateEvent()
      }
    },
    onCopy() {
      this.$vs.notify({
        title: 'Success',
        text: 'Text copied successfully',
        color: 'success',
        iconPack: 'feather',
        position: 'top-center',
        icon: 'icon-check-circle'
      })
    },
    onError() {
      this.$vs.notify({
        title: 'Failed',
        text: 'Error in copying text',
        color: 'danger',
        iconPack: 'feather',
        position: 'top-center',
        icon: 'icon-alert-circle'
      })
    },
  }
}
</script>
